export enum AccountActionTypes {
  GetAccountLocal = 'GetAccountLocal',
  SetAccount = 'SetAccount',
  DeleteAccount = 'DeleteAccount',
}
